/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ButtonBase } from '../button/ButtonBase';

const CardAction = ({ children, href, onClick, className }) => {

  const classes = classNames(className,
    'sui-items-stretch focus-visible:sui-outline-focus focus-visible:sui-outline focus-visible:sui-outline-4 hover:sui-shadow-lg'
  );

  const actionProps = {
    children,
    className: classes
  };

  let CardActionRoot = 'div';
  if (onClick) {
    CardActionRoot = ButtonBase;
    actionProps.onClick = onClick;
    actionProps.unstyled = true;
  } else if (href) {
    CardActionRoot = 'a';
    actionProps.href = href;
  }

  return (
    <CardActionRoot
      {...actionProps}
    />
  );
};

CardAction.displayName = 'CardAction';

CardAction.propTypes = {
  className: PropTypes.string,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  href: PropTypes.string,
  onClick: PropTypes.func
};

CardAction.defaultProps = {
};

export { CardAction };